// export function fetchUserInfo(): Promise<>
import request from "./utils/request";

export interface ILoginPayload {
  type?: string;
  username: string;
  password: string;
  remember: boolean;
}

export interface ILoginResponse {
  token: {
    expAt: string;
    token: string;
  };
  profile: {
    lastVisitedSiteId?: string;
  };
}

export function login(payload: ILoginPayload): Promise<ILoginResponse> {
  console.log('登录请求参数:', payload);

  // 实际API调用（连接到后端服务端口3001）
  return request.post("/auth/login", {
    username: payload.username,
    password: payload.password,
    remember: payload.remember
  });
}

export function logout(): Promise<{}> {
  return request.post("/auth/logout");
}

export interface IUserProfile {
  isAdmin: boolean;
  activedAt: string;
  username: string;
  name: string;
  email: string;
  createdAt: string;
  updatedAt: string;
  lastVisitedSiteId: string;
}

export function fetchCurrentUserProfile(): Promise<{ profile: IUserProfile }> {
  // 实际API调用（连接到后端服务端口3001）
  return request.get("/user/profile");
}

interface IRegisterUserPayload {
  username: string;
  password: string;
  name: string;
  email: string;
  mobilePhone: string;
  code: string;
}

export const registerUser = (payload: IRegisterUserPayload) => {
  console.log('注册请求参数:', payload);

  // 实际API调用（连接到后端服务端口3001）
  return request.post("/user/register", payload);
};
